import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const JobFitProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="JobFit Assessment Nigeria | Graduate Role Fit Test Lagos"
        description="JobFit™ graduate recruitment assessment for Nigerian employers. Assess role fit, behavioural alignment, and job readiness for graduate schemes and trainee programmes. Used by leading Nigerian banks and corporates."
        keywords="graduate assessment Nigeria, job fit test Lagos, role fit assessment Nigeria, graduate recruitment test Africa, behavioural assessment graduates Nigeria"
        canonical="https://impactasportal.com/product/jobfit"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/jobfit?embed=true"
            title="JobFit™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default JobFitProductPage;
